export default __webpack_public_path__ + "static/media/melat.d281117d.png";